import { render, staticRenderFns } from "./DocumentsShowTable.vue?vue&type=template&id=4a6cc362&"
import script from "./DocumentsShowTable.vue?vue&type=script&lang=js&"
export * from "./DocumentsShowTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports